export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Taxonomy.vue?vue&type=template&id=4a448385"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Taxonomy.vue?vue&type=template&id=4a448385
// module id = 88
// module chunks = 0